export default class Qt {
  constructor(t) {
    (this.yl = t), (this.yl = t);
  }
  Bl(t) {
    return null == this.yl || this.yl === t[0];
  }
  static fromJson(t) {
    return new Qt(t ? t.event_name : null);
  }
  ss() {
    return this.yl;
  }
}
